import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles(({ colors }) => ({
  loaderWrapper: () => ({
    margin: 'auto',
    background: 'rgba(136, 136, 136, 0.3)',
    backdropFilter: 'blur(50px)',
    width: 200,
    height: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 30,
    '& svg': {
      width: 50,
      height: 50
    }
  })
}));
